import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import './BreadCrumbs.scss';
import { Link } from "react-router-dom";
import { Routes } from "@core/routes";

export type BreadCrumbsItem = {
    id: string;
    name: string;
    testId?: string;
    path?: string;
    onClick?: () => void;
    [key: string]: any;
};

const BreadCrumbs: FCX<{
    items: BreadCrumbsItem[];
}> = ({
    items,
    style,
    className,
    testId,
}) => {
    return (
        <div
            className={cn("BreadCrumbs", className)}
            style={style}
            data-testid={testId}
        >
            {items.map(({
                id,
                name,
                testId,
                path,
                onClick,
                className: itemClassName,
                ...rest
            }) => (
                <Link
                    key={id}
                    className={cn(
                        "BreadCrumbs__item",
                        itemClassName,
                        !path && "is-static",
                    )}
                    data-testid={testId}
                    to={path ?? Routes.Home}
                    onClick={onClick}
                    {...rest}
                >
                    {name}
                </Link>
            ))}
        </div>
    );
}

export default BreadCrumbs;